
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/mobile/prepay/handset/[title]",
      function () {
        return require("private-next-pages/shop/mobile/prepay/handset/[title].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/mobile/prepay/handset/[title]"])
      });
    }
  